import { MediaType } from "./ui-types";


export class MediaData {
    constructor(
        public type: MediaType,
        public caption?: string,
        public small?: File,
        public id?: number) { }
}


export class UploadedMedia extends MediaData {
    constructor(
        public large: File,
        public small: File,
        public type: MediaType,
        public caption?: string,
        public id?: number) {
        super(type, caption, small, id);
    }
};

export class MediaURL extends MediaData {
    constructor(
        public url: string,
        public type: MediaType,
        public caption?: string,
        public id?: number,
        public small?: File,) {
        super(type, caption, small, id);
    }
}

export const UPLOAD_MAX_FILES = 20;
export const UPLOAD_MAX_MEDIA_SIZE = 4;
export const UPLOAD_MAX_DOC_FILE_SIZE = 2;
export const UPLOAD_MAX_THUMB_SIZE = 0.5;
export const UPLOAD_ALLOWED_MEDIA_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
export const UPLOAD_ALLOWED_DOC_FILE_EXTENTIONS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.pptx'];